import PosCartStore from '../../../stores/PosCartStore';
import UserStore from '../../../stores/UserStore';

import Price from '../../form/Price.react';
import Increase from '../selected/Increase.react';
import Decrease from '../selected/Decrease.react';
import InfoButton from '../selected/InfoButton.react';

class PosSearch extends React.Component {

    render() {
        var self                = this;
        var page                = this.props.page;
        var guest               = this.props.guest;
        var cart                = this.props.cart;
        var query               = this.props.query.trim().toLowerCase();
        var qtyInCart           = false;
        let selectedLocation = UserStore.getState().selectedLocation;
        let hidePlusMinus = !selectedLocation.EnableSearchPlusMinus;

        // var searchResults       = this.props.searchResults;

        var searchResults = this.props.productList.filter(x => {
            return (
                x.ProductDesc.toLowerCase().indexOf(query) >= 0 ||
                x.ProductNo.toLowerCase().indexOf(query) >= 0 ||
                x.SerialNo.toLowerCase().indexOf(query) >= 0
            );
        });

        return (
            <div className='pos-search'>
                <div className='pos-search__content'>

                    <div className='pos-search__results'>

                        <div className='pos-search__header'>

                            <div className='pos-search__header--avail'>
                                Avail
                            </div>
                            <div className='pos-search__header--desc'>
                                Description
                            </div>
                        </div>

                        { searchResults.slice(0, 500).map((item, i) => {
                            qtyInCart = PosCartStore.getQtyInCartBySerialNo(item.SerialNo);
                            var price = item.UnitPrice;
                            if (selectedLocation.DualPricing) {
                                price = guest.IsMedical ? item.UnitPrice : item.RecUnitPrice;
                            }

                            return (
                                <div
                                    className={'pos-search__item '+(i % 2 ? 'pos-search__item--grey' : '')}
                                    key={item.uuid}>

                                    <div className='pos-search__item--available'>
                                        {item.TotalAvailable}
                                    </div>

                                    <div className='pos-search__item--desc'>
                                        {item.ProductDesc}
                                    </div>

                                    <div className='pos-search__item--serial'>
                                        {item.SerialNo}
                                    </div>

                                    <div className='pos-search__item--price'>
                                        <Price price={price} dollar={true} />
                                    </div>

                                    <div className='pos-search__item--weight'>
                                        {item.UnitGrams}g
                                    </div>

                                    { qtyInCart &&
                                        <div className='pos-search__item--qty'>
                                            {qtyInCart}
                                        </div>
                                    }

                                    <Increase
                                        item={item}
                                        guest={guest}
                                        hide={hidePlusMinus}
                                        page='search' />

                                    <Decrease
                                        item={item}
                                        guest={guest}
                                        hide={hidePlusMinus}
                                        page='search' />

                                    <InfoButton
                                        item={item}
                                        guest={guest}
                                        page='search' />
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        );
    }
}

export default PosSearch;



// WEBPACK FOOTER //
// ./ui_src/app/components/pos/search/PosSearch.react.jsx